var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_wrap",style:({height:_vm.compHeight})},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }